import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeBox() {
  return <div className="inline-flex items-center gap-2.5 mx-auto rounded-lg" style={{
    background: 'rgba(207, 155, 46, 0.06)',
    border: '1px solid rgba(207, 155, 46, 0.25)',
    padding: '10px 16px'
  }} data-id="element-151">
      <ShieldCheckIcon className="w-5 h-5 text-[#CF9B2E] flex-shrink-0" data-id="element-152" />
      <div className="text-left leading-tight" data-id="element-153">
        <p className="text-[#CF9B2E] font-bold text-sm tracking-wide" data-id="element-154">
          Garantía de 14 días
        </p>
        <p className="text-[#E8D5B0] text-[12px]" data-id="element-155">
          Garantía total de satisfacción.
        </p>
      </div>
    </div>;
}